import React, { useMemo } from "react";
import type { UtilizationTrendItem } from "../../type";
import {
  MultiDimensionBarChart,
  type MultiDimensionBarRow,
} from "../ChartTypes/MultiDimensionBarChart";
import {
  EMPTY_UTILIZATION_STATE_MESSAGE,
  MONTH_SHORT,
  UTILIZATION_DIMENSIONS,
} from "../../../../utils/consts";

const formatYAxisPercent = (val: number) => `${Number(val).toFixed(1)}%`;
const formatTooltipPercent = (val: number) => `${Number(val).toFixed(2)}%`;

export interface UtilizationBreakdownTrendChartProps {
  title: string;
  loading?: boolean;
  series: UtilizationTrendItem[];
}

export const UtilizationBreakdownTrendChart: React.FC<
  UtilizationBreakdownTrendChartProps
> = ({ title, loading = false, series }) => {
  const rows = useMemo<MultiDimensionBarRow[]>(
    () =>
      series.map((item) => ({
        category: `${MONTH_SHORT[item.month - 1] ?? item.month} ${item.year}`,
        values: {
          deployed: Number(item.deployed),
          client: Number(item.client),
          billed: Number(item.billed),
        },
      })),
    [series],
  );

  return (
    <MultiDimensionBarChart
      title={title}
      loading={loading}
      dimensions={UTILIZATION_DIMENSIONS}
      rows={rows}
      height={400}
      valueSuffix="%"
      yAxisValueFormatter={formatYAxisPercent}
      tooltipValueFormatter={formatTooltipPercent}
      xAxisRotateThreshold={5}
      legendTop={5}
      legendRight={40}
      emptyMessage={EMPTY_UTILIZATION_STATE_MESSAGE}
    />
  );
};
